import { ApiResult } from '@synergy/api';
import { PaginatedResponse } from '@synergy/api';
import { request, safeRequest } from '@synergy/api';

import { Inquiry } from './models/inquiry';
import { InquiryRequest } from './models/inquiry-request';

export class InquiryApi {
    constructor(protected baseUrl: string) {}

    public get(id: number): Promise<ApiResult<Inquiry>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/inquiries/${id}`),
            response => Inquiry.fromPlainObject(response.data)
        );
    }

    public post(inquiry: InquiryRequest): Promise<ApiResult<Inquiry>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/inquiries`, inquiry, {
                    params: { isSync: true },
                }),
            response => Inquiry.fromPlainObject(response.data)
        );
    }

    public patch(id: number, inquiry: Partial<InquiryRequest>): Promise<ApiResult<Inquiry>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/inquiries/${id}`, inquiry),
            response => Inquiry.fromPlainObject(response.data)
        );
    }

    public cget(params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<Inquiry>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/inquiries`, { params }),
            response => {
                response.data.items = response.data.items.map(Inquiry.fromPlainObject);
                return response.data;
            }
        );
    }

    public delete(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/inquiries/${id}`, { params: { isSync: true } }),
            () => null
        );
    }

    public copyInquiry(id: number): Promise<ApiResult<Inquiry>> {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/inquiries/${id}/copy`,
                    {},
                    {
                        params: { isSync: true },
                    }
                ),
            response => response.data
        );
    }

    public export(params: URLSearchParams): Promise<ApiResult<Blob>> {
        const exportFields = [
            'number',
            'status',
            'title',
            'accountPurchases.customerAccount.id',
            'accountPurchases.customerAccount.name',
            'responsibleContact.fullName',
            'createdAt',
            'endDate',
        ];
        params.append('fields', exportFields.join(','));
        return safeRequest(
            () => request.get(`${this.baseUrl}/inquiries.csv`, { params, responseType: 'blob' }),
            response => response.data
        );
    }

    public rate(id: number, rating: number): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.post(
                    `${this.baseUrl}/inquiries/${id}/rate`,
                    { rating },
                    {
                        params: { isSync: true },
                    }
                ),
            () => null
        );
    }
}
